import {
    $, addFilter, addAction, INIT,
} from '@situation/setdesign.util';

addFilter('content-slider/owl-settings', (settings) => ({
    ...settings,
    navText: [
        '<svg><use xlink:href="#icon-arrow-circle"></use></svg>',
        '<svg><use xlink:href="#icon-arrow-circle"></use></svg>',
    ],
}));

addAction('content-slider/init', ($slider) => {
    const $dots = $slider.find('.owl-dots');
    $slider.find('.owl-prev').after($dots);
    $slider.addClass('content-slider--show');
});

addAction(INIT, () => {
    $('.content-slider').each(() => {
        const $container = $(this);
        const $slides = $container.find('.content-slide');
        if ($slides.length < 2) {
            $container.addClass('content-slider--show');
        }
    });
});
